<section class="portal-list">
  @if (showEmptyState) {
    <div class="create-portal">
      <h1>{{ 'myPortals.title' | translate }}</h1>
      <div class="modal-center">
        <img src="../../assets/icons/box.svg" alt="imagen de cubo">
        <p>{{ 'myPortals.welcome' | translate }}</p>
        <button (click)="goSettings()">{{ 'myPortals.createButton' | translate }}</button>
      </div>
    </div>
  } @else {
    @if (showToolbar) {
      <div class="portal-list__toolbar">
        <div class="portal-list__search-wrap">
          <input
            type="text"
            class="portal-list__search"
            [formControl]="searchControl"
            [placeholder]="'myPortals.list.searchPlaceholder' | translate">
          @if (searchControl.value) {
            <button
              type="button"
              class="portal-list__search-clear"
              (mousedown)="$event.preventDefault()"
              (click)="clearSearch()"
              [attr.aria-label]="'myPortals.list.clearSearch' | translate">
              &times;
            </button>
          }
        </div>
        <div class="portal-list__filters">
          <button type="button" [class.active]="statusFilter === 'all'" (click)="setStatusFilter('all')">
            {{ 'myPortals.list.filterAll' | translate }}
          </button>
          <button type="button" [class.active]="statusFilter === 'active'" (click)="setStatusFilter('active')">
            {{ 'myPortals.list.filterActive' | translate }}
          </button>
          <button type="button" [class.active]="statusFilter === 'inactive'" (click)="setStatusFilter('inactive')">
            {{ 'myPortals.list.filterInactive' | translate }}
          </button>
        </div>
      </div>
    }

    @if (listLoading) {
      <div class="portal-list__loading">{{ 'myPortals.list.loading' | translate }}</div>
    }

    @if (!listLoading && page && page.portals.length === 0) {
      <div class="portal-list__no-results">
        <p>{{ 'myPortals.list.noResults' | translate }}</p>
      </div>
    }

    @for (portal of page?.portals ?? []; track portal.id) {
      <app-my-portal [portal]="portal"></app-my-portal>
    }

    @if (page && page.pages > 1) {
      <nav class="portal-list__paginator">
        <button type="button" [disabled]="pageIndex === 0" (click)="goToPage(pageIndex - 1)">
          {{ 'myPortals.list.prev' | translate }}
        </button>
        @for (n of pageNumbers; track n) {
          <button type="button" class="portal-list__page" [class.active]="n === pageIndex" (click)="goToPage(n)">
            {{ n + 1 }}
          </button>
        }
        <button type="button" [disabled]="pageIndex >= page.pages - 1" (click)="goToPage(pageIndex + 1)">
          {{ 'myPortals.list.next' | translate }}
        </button>
        <label class="portal-list__size">
          {{ 'myPortals.list.pageSize' | translate }}
          <select #sizeSel (change)="setPageSize(+sizeSel.value)">
            @for (opt of pageSizeOptions; track opt) {
              <option [value]="opt" [selected]="opt === pageSize">{{ opt }}</option>
            }
          </select>
        </label>
      </nav>
    }
  }
</section>
